import React from 'react';
import { connect } from 'react-redux'

import Row from "./row"
import AddRow from "./addRow";

import {selectRow} from "../../actions/index";

const IfElseEditor = ({ content, sectionName, parentIndex, handleRowSelection, row, parentRowId }) => {
    const ifContent = content.config.if.content;
    const elseContent = content.config.else.content;
    return (
        <div style={{border: "dashed 1px lightgray", margin: "2px"}}>
            <div style={{textDecoration: "underline"}}>If block</div>
            <div>{ifContent.map((ifContent, index) => (
                <Row
                    content={ifContent}
                    id={ifContent.id} 
                    selected={row.selected === ifContent.id}
                    onSelection={handleRowSelection}
                    parentIndex={parentIndex}
                    sectionName={sectionName}
                    key={index}
                />
            ))}
            <AddRow allowIf={false} list={ifContent} lastRowId={ifContent.length > 0 ? ifContent[ifContent.length - 1].id : `${parentRowId}if0`}/>
            </div>
            <div style={{textDecoration: "underline"}}>Else block</div>
            <div>{elseContent.map((elseContent, index) => (
                <Row
                    content={elseContent}
                    id={elseContent.id} 
                    selected={row.selected === elseContent.id}
                    onSelection={handleRowSelection}
                    parentIndex={parentIndex}
                    sectionName={sectionName}
                    key={index}
                />
            ))}
            <AddRow allowIf={false} list={elseContent}  lastRowId={elseContent.length > 0 ? elseContent[elseContent.length - 1].id : `${parentRowId}else0`}/>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return { 
        row: state.row
    }
}

const mapDispatchToProps = dispatch => {
    return {
        handleRowSelection: id => {
            dispatch(selectRow(id))
        }
    }
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IfElseEditor);